import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import RangeSlider from "./rangeSlider";
import { Link } from "react-router-dom";

const filter = () => {
  // const activeStyle = ({ isActive }) => {
  //     return {

  //         fontWeight: isActive ? 'bold' : 'normal',
  //         textDecoration: isActive ? "none" : 'underline',
  //         listStyle: isActive ? "inside" : "none",

  //     }
  // }
  return (
    <section className="filter">
      <Row>
        <Col>
          <div className="filter-wrap">
            <div className="filter-title seats">Seats</div>
            <div className="range-slider">
              <RangeSlider />
            </div>
            <div className="car-types filter-title">Car Types</div>
            <div className="car-list-type">
              <ul>
                <li className="active">
                  <Link className="li-link" to="">
                    Xuv
                  </Link>
                </li>
                <li>
                  <Link className="li-link" to="">
                    Bmw
                  </Link>
                </li>
                <li>
                  <Link className="li-link" to="">
                    Sedan
                  </Link>
                </li>
              </ul>
            </div>
            <div className="transmission filter-title">Transmission</div>
            <div className="transmission-types">
              <ul>
                <li>
                  <Link className="li-link" to="">
                    Manual
                  </Link>
                </li>
                <li>
                  <Link className="li-link" to="">
                    Automatic
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </Col>
      </Row>
    </section>
  );
};

export default filter;
